import { State } from '../../reducers/rootReducer'
import ComparisonData from '../../../entities/ComparisonData'

const comparisonDataSelector = (state: State): ComparisonData => state.comparisonData

export default comparisonDataSelector
